var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "Map",
        {
          attrs: { locale: "en", mapboxAccessToken: _vm.mapboxAccessToken },
          on: { "map-loaded": _vm.onMapLoaded },
        },
        [
          _c("MeasurementControl", { attrs: { position: "top-right" } }),
          _c("DrawControl", { attrs: { position: "top-right" } }),
          _c("SettingControl", { attrs: { position: "bottom-right" } }),
          _c("LayerControl", { attrs: { position: "top-left" } }),
          _c("CrsControl"),
          _c("PrintControl"),
          _c("GeoLocateControl"),
          _c("HomeControl"),
          _c("ZoomControl"),
          _c("FullScreenControl"),
          _c("BaseMapControl", { attrs: { position: "bottom-left" } }),
          _c("MouseCoordinatesControl"),
          _c("IdentifyControl", { attrs: { position: "top-right" } }),
          _c("ActionControl"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }